import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { html } from 'lit';
import { getMyUserPreferences } from '../../api/getMyUserPreferences.js';
import { setMyQuestionMailPreference } from '../../api/setMyQuestionMailPreference.js';

/** Personal dashboard preferences, as a full screen (replaces the old header popup). */
export const SettingsPage = stateful(() => {
  const [version, setVersion] = useState(0);
  const { value: prefs, loading } = useQuery(
    () => getMyUserPreferences()({ _id: 1, receiveQuestionMails: 1 }),
    [version],
  );
  // Absent preferences mean the user never touched the setting, and the channel is on by
  // default — so a missing document has to read as enabled here too, or the toggle would
  // show "off" while mails are going out.
  const enabled = prefs?.receiveQuestionMails ?? true;

  const toggle = async (checked: boolean) => {
    try {
      await setMyQuestionMailPreference(checked)();
      setVersion(version + 1);
    } catch (e: any) {
      XSnackbar.show('Einstellung konnte nicht gespeichert werden: ' + e.message);
    }
  };

  return html`
    <div class="p-6 max-w-3xl mx-auto">
      <h1 class="text-2xl font-bold tracking-tight">Einstellungen</h1>
      <p class="text-base-content/60 mt-1 mb-6">Persönliche Einstellungen für dieses Dashboard.</p>

      <div class="rounded-2xl bg-base-100 border border-base-200 shadow-sm">
        <div class="px-5 py-4 border-b border-base-200">
          <h2 class="text-sm font-semibold uppercase tracking-wide text-base-content/50">Benachrichtigungen</h2>
        </div>
        <label class="flex items-start justify-between gap-6 p-5 cursor-pointer">
          <span>
            <span class="block font-medium">Rückfragen per Mail erhalten</span>
            <span class="block text-sm text-base-content/60 mt-1 max-w-xl">
              Wenn zu einer von Ihnen weitergeleiteten Anfrage etwas offen ist, schicken wir Ihnen die Punkte per
              Mail. Sie können direkt auf diese Mail antworten — je Punkt eine Zeile, etwa „1: A" oder „1: 6 m".
              Ist das aus, erscheinen die Rückfragen nur im Dashboard.
            </span>
          </span>
          <input
            type="checkbox"
            class="toggle toggle-primary mt-1 shrink-0"
            ?disabled=${loading}
            .checked=${enabled}
            @change=${(e: Event) => toggle((e.target as HTMLInputElement).checked)}
          />
        </label>
      </div>
    </div>
  `;
});
